import { memo, useState } from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CloseIcon, ConnectIcon } from '~/assets/icons';
import useQuickbook from '~/hooks/useQuickbook';
import ModalAlertConfirm from '~/components/common/modal-alert-confirm/ModalAlertConfirm';

const QuickbookConnectButton = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { connectQuickbook, quickbook, disconnectQuickbook } = useQuickbook();
  const { t } = useTranslation(['admin/quickbook']);
  //#endregion Declare Hook

  //#region Selector

  //#endregion Selector

  //#region Declare State
  const [openDisconnectConfirm, setOpenDisconnectConfirm] = useState<boolean>(false);
  //#endregion Declare State

  //#region Implement Hook

  //#endregion Implement Hook

  //#region Handle Function
  const handleDisconnectConfirm = () => {
    setOpenDisconnectConfirm(false);
    disconnectQuickbook();
  };
  //#endregion Handle Function

  return (
    <>
      {quickbook && (
        <Box>
          {quickbook.isQuickbookConnected ? (
            <Button
              variant='contained'
              color='error'
              onClick={() => setOpenDisconnectConfirm(true)}
              startIcon={<CloseIcon className='w-[12px] h-[12px] [&>path]:fill-[#FFFFFF]' />}
            >
              {t('disconnectQuickbook')}
            </Button>
          ) : (
            <Button
              variant='contained'
              onClick={connectQuickbook}
              startIcon={<ConnectIcon className='w-[12px] h-[12px]' />}
            >
              {t('connectQuickbook')}
            </Button>
          )}
        </Box>
      )}
      <ModalAlertConfirm
        open={openDisconnectConfirm}
        description={t('disconnectConfirmDesciption')}
        confirm={t('disconnectConfirmYes')}
        onCancel={() => {
          setOpenDisconnectConfirm(false);
        }}
        onConfirm={handleDisconnectConfirm}
      />
    </>
  );
};

export default memo(QuickbookConnectButton);
